import React, { useState } from "react";
import Header from "./layers/Header";
import Footer from "./layers/Footer";
import axios from "axios";
import { useParams } from "react-router-dom";

const ReviewPage = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // extract patientId from URL
  const { patientId } = useParams();

  const handleSubmit = async () => {
    if (!rating) return alert("Please select a rating");

    try {
      setLoading(true);

      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/reviews`, {
        patientId,
        rating,
        comment,
      });

      setSubmitted(true);
    } catch (err) {
      console.error(err);
      alert("Failed to submit review");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="min-h-[100vh] flex items-center justify-center bg-[#F7F8F0] px-4 py-16">
        <div className="bg-white rounded-2xl shadow-md p-6 w-full max-w-md text-center">
          <div className="flex justify-center mb-4">
            <div className="flex items-center space-x-2 cursor-pointer">
              <img src="/zavira.png" alt="Logo" className="w-8 h-8" />
              <h1 className="text-xl font-semibold text-[#1E0E62]">
                ZaviraMed
              </h1>
            </div>
          </div>
          {!submitted ? (
            <>
              <h2 className="text-2xl font-bold text-[#1E0E62] mb-2">
                How are you feeling?
              </h2>
              <h2 className="text-2xl font-bold text-[#1E0E62] mb-2">
               How was your consultation?
              </h2>

              How was your consultation?

              <p className="text-sm text-gray-500 mb-6">
                Your feedback helps us improve your care
              </p>

              {/* ⭐ STARS */}
              <div className="flex justify-center mb-6">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`text-3xl cursor-pointer transition ${
                      (hover || rating) >= star
                        ? "text-yellow-400"
                        : "text-gray-300"
                    }`}
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHover(star)}
                    onMouseLeave={() => setHover(null)}
                  >
                    ★
                  </span>
                ))}
              </div>

              {/* COMMENT */}
              <textarea
                placeholder="Tell us more (optional)..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full border rounded-xl p-3 text-sm mb-4 outline-none"
                rows={4}
              />

              {/* SUBMIT */}
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="w-full bg-[#25DAC5] text-white py-3 rounded-xl font-medium"
              >
                {loading ? "Submitting..." : "Submit Review"}
              </button>
            </>
          ) : (
            <div className="py-10">
              <h2 className="text-2xl font-bold text-[#1E0E62] mb-3">
                Thank You ❤️
              </h2>
              <p className="text-gray-500 text-sm">
                Your feedback has been received. We’re glad we could care for
                you.
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ReviewPage;
